var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { LeaveSpacesService } from '@/domains/spaces/services/leave-space-service.interface';
import { AbstractSpaceActionService } from '@/services/space-action-service';
import { ConfirmService } from '@/services/confirm-service.interface';
import { I18nService } from '@/services/i18n-service';
import { RavenService } from '@cores/modules/raven-module/raven-service';
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceLabelService } from '@/domains/spaces/services/space-label-service.interface';
let LeaveSpaceContribution = class LeaveSpaceContribution extends AbstractSpaceActionService {
    constructor(_logger, _i18nService, _ravenService, _selectSpacesService, _confirmService, _spaceLabelService) {
        super();
        this._logger = _logger;
        this._i18nService = _i18nService;
        this._ravenService = _ravenService;
        this._selectSpacesService = _selectSpacesService;
        this._confirmService = _confirmService;
        this._spaceLabelService = _spaceLabelService;
    }
    async _execute() {
        const bool = await this._confirmService.confirm({
            title: this._i18nService.t('workspace.labels.exitTitle'),
            message: this._i18nService.t('workspace.labels.exitMsg'),
            confirmText: this._i18nService.t('global.btn.ok'),
            cancelText: this._i18nService.t('global.btn.cancel'),
            type: 'error',
        });
        bool ? this._onConfirmed() : this._onAborted();
    }
    async _onConfirmed() {
        const { spaceId } = this.currentSpaceService.getCurrentSpace();
        await this._selectSpacesService.leaveSpaces([spaceId]);
        this._spaceLabelService.resetSpaceLabel();
        this._track([spaceId]);
    }
    _track(spaceIds) {
        if (spaceIds.length > 1) {
            this._ravenService.track('Reject Workspaces', { workspace_id: spaceIds[0] });
        }
        else {
            this._ravenService.track('Batch Reject Workspace', { workspace_ids: spaceIds });
        }
    }
    _onAborted() {
        this._logger.info('Leave Space Aborted');
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'leave-space',
        }, {
            execute: () => {
                return this._execute();
            },
        });
    }
    registerSpaceActions(spaceActionRegistry) {
        spaceActionRegistry.registerSpaceAction({
            order: 99,
            commandId: 'leave-space',
            label: this._i18nService.t('global.btn.leaveShare'),
            iconClass: 'SolidLogout',
            isEnabled: (space) => {
                return space.isShared;
            },
            isVisible: (space) => {
                return space.isShared;
            },
        });
    }
};
LeaveSpaceContribution = __decorate([
    injectable(),
    __param(0, inject(Logger)),
    __param(1, inject(I18nService)),
    __param(2, inject(RavenService)),
    __param(3, inject(LeaveSpacesService)),
    __param(4, inject(ConfirmService)),
    __param(5, inject(SpaceLabelService)),
    __metadata("design:paramtypes", [typeof (_a = typeof Logger !== "undefined" && Logger) === "function" ? _a : Object, typeof (_b = typeof I18nService !== "undefined" && I18nService) === "function" ? _b : Object, typeof (_c = typeof RavenService !== "undefined" && RavenService) === "function" ? _c : Object, typeof (_d = typeof LeaveSpacesService !== "undefined" && LeaveSpacesService) === "function" ? _d : Object, typeof (_e = typeof ConfirmService !== "undefined" && ConfirmService) === "function" ? _e : Object, typeof (_f = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _f : Object])
], LeaveSpaceContribution);
export { LeaveSpaceContribution };
